import { render, staticRenderFns } from "./PriorAuthorizationListComponent.vue?vue&type=template&id=1789889e&scoped=true"
import script from "./PriorAuthorizationListComponent.vue?vue&type=script&lang=ts"
export * from "./PriorAuthorizationListComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789889e",
  null
  
)

export default component.exports